<script>
import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net-bm';
import jszip from 'jszip';
import pdfmake from 'pdfmake';
import 'datatables.net-buttons-bm';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-colreorder-bm';
import 'datatables.net-fixedcolumns-bm';
import 'datatables.net-fixedheader-bm';
import 'datatables.net-responsive-bm';
import 'datatables.net-rowgroup-bm';
import 'datatables.net-scroller-bm';
import 'datatables.net-searchbuilder-bm';
import 'datatables.net-searchpanes-bm';
import 'datatables.net-select-bm';

import {ModalsContainer, useModal} from 'vue-final-modal'
import vueFinalModal from '@/components/subcomponents/vueFinalModal.vue'


DataTable.use(jszip);
DataTable.use(pdfmake);
DataTable.use(DataTablesLib);

const vfs = require('pdfmake/build/vfs_fonts')
window.pdfMake.vfs = vfs.pdfMake.vfs


export default {
  inject: ['$axios', '$_', '$apiBaseURL', '$appVer'],
  emits: ["tableRefreshTrigger", "totalRecords", "previewSummaries", "selectedInvoiceRows"],
  props: {
    tableData: Object,
    tableRef: String,
    loginData: Object,
    filterForPartner: String,
    drawTime: Number,
    updatePatientInvoiceRefresh: Number,
    financeReportsYear: Object,
    financeReportsPocket: Object,
    financeReportsGroup: Object,
    adminGroup: Object,
    invoiceAddingTime: Number,
    rowSelectedCheck: Object
  },
  data() {
    return {
      awaitingPartnerInvoiceDataInvoice: {},
      awaitingPaymentDetailsDataRemittance: {},
      showPartnerRemittanceModal: false,
      remittanceInvoiceSelect: {},
      componentMounted: false,

      showExportingModal: false,
      modalTitle: 'Modal',

      thisDT: null,
      searchBuilderObject: {},
      currentDisplayedData: {},
      currentDisplayedDataFull: {},
      currentDisplayedDataConfig: {},
    }
  },
  name: "dataTablesComponent",
  components: {
    DataTable,
    ModalsContainer
  },
  methods: {
    displayExportModal: function () {
      let vm = this;

      const {open: openExportsModal, close: closeExportsModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Export Data',
          formFor: 'tableExports',
          currentTableData: vm.currentDisplayedData[vm.tableRef],
          currentTableConfig: vm.currentDisplayedDataConfig[vm.tableRef],
          tableRef: vm.tableRef,
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeExportsModal()
          },
        },
        slots: {
          default: '<p>Please select your preference</p>',
          fileType: '<p>Please select the file type</p>',
          fileScope: '<p>Please select the scope of the exported data</p>'
        },
      });

      openExportsModal();
    },
    displayPartnerRemittanceModal: function (partnerId, pocket) {
      let vm = this,
          submittingCases = [];

      vm.$_.forEach(vm.remittanceInvoiceSelect, function (remittanceInvoiceSelectState, remittanceInvoiceSelectKey) {
        if (remittanceInvoiceSelectKey.indexOf(`${partnerId}-${pocket}-`) === 0 && remittanceInvoiceSelectState) {
          submittingCases.push(remittanceInvoiceSelectKey);
        }
      });

      vm.showPartnerRemittanceModal = true;
    },
    xhrReportDraw: function (eventandDT) {
      let vm = this;
      vm.thisDT = eventandDT.dt;
      vm.thisDT.off('preXhr.dtsb');

      vm.thisDT.on('preXhr.dtsb', function (event, settings, data) {
        if (vm.thisDT.page.info().serverSide) {
          if (typeof data !== 'string') {
            data.searchBuilder = event.dt.searchBuilder.getDetails(true);
          }
        }
      });
      vm.thisDT.on('preXhr.dt', function (event, settings, data) {
        if (vm.thisDT.searchBuilder) {
          if (typeof data === 'string') {
            data = JSON.stringify(vm.$_.assignIn({}, JSON.parse(data), {searchBuilder: vm.thisDT.searchBuilder.getDetails(true)}));
          } else {
            data = vm.$_.assignIn({}, data, {searchBuilder: vm.thisDT.searchBuilder.getDetails(true)});
          }

          vm.searchBuilderObject = vm.thisDT.searchBuilder.getDetails(true);
        }
      });
    },
    preXhr: function () {
    },
    xhr: function (event, settings, data) {
      let vm = this;

      if (typeof data.recordsTotal !== 'undefined') {
        vm.$emit('totalRecords', {count: data.recordsFiltered, tableRef: vm.tableRef});
      }

      vm.currentDisplayedData[vm.tableRef] = [];
      vm.currentDisplayedDataFull[vm.tableRef] = [];
      vm.$_.forEach(data.data, function (dataRow) {
        vm.currentDisplayedData[vm.tableRef].push(`${dataRow.partnerid}_${dataRow.caseid}`);
        vm.currentDisplayedDataFull[vm.tableRef].push(dataRow);
      });

      if (vm.tableRef === 'invoicedPreviewForAmhInvoice') {
        let safeAsk = {count: 0, total: 0},
            invoice = {},
            allCaseIds = [];
        vm.$_.forEach(data.data, function (dataRow) {
          safeAsk.count += 1;
          safeAsk.total += parseFloat(dataRow.p_safeaskamount);
          if (typeof invoice[dataRow.prt_inv_currency] !== 'undefined') {
            invoice[dataRow.prt_inv_currency].count += 1;
            invoice[dataRow.prt_inv_currency].total += parseFloat(dataRow.prt_inv_amount);
          } else {
            invoice[dataRow.prt_inv_currency] = {count: 1, total: parseFloat(dataRow.prt_inv_amount)};
          }
          allCaseIds.push(dataRow.caseid);
        });

        vm.$emit('previewSummaries', {safeAsk: safeAsk, invoice: invoice, allCaseIds: allCaseIds});
      }

    },
    dtsbInserted: function () {
    },
  },
  computed: {
    tableOptions: function () {
      let vm = this,
          defaultOptions = {
            responsive: {
              details: {
                renderer: DataTablesLib.Responsive.renderer.listHiddenNodes()
              }
            },
            select: true,
            layout: {
              top: 'info',
              topStart: 'pageLength',
              topEnd: 'search',
              bottomStart: 'buttons',
              bottomEnd: 'paging'
            },
            buttons: ['copy', 'csvHtml5', 'pdf', 'print'],
            columnDefs: [],
            colReorder: {}
          };
      let rowGrouping = [];

      switch (vm.tableRef) {
        case 'profileSubmissionReportData':
          if (vm.loginData.role === 'Coordinator') {

            defaultOptions.colReorder = {
              order: [10, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            };
            defaultOptions.columnDefs.push({
              target: 0,
              visible: false,
              searchable: false
            });
            defaultOptions.rowGroup = {
              dataSrc: 'monthYear',
              startRender: function (rows, group) {
                return `${group}`;
              }
            }
          }
          if (vm.loginData.role === 'Representative') {
            defaultOptions.select = false;
          }
          break;
        case 'fundsUtilizationReportData':
          if (vm.loginData.role === 'Coordinator') {
            defaultOptions.colReorder = {
              order: [6, 0, 1, 2, 3, 4, 7, 5]
            };
            defaultOptions.columnDefs.push({
              target: 0,
              visible: false,
              searchable: false
            });
            defaultOptions.rowGroup = {
              dataSrc: 'monthYear',
              startRender: function (rows, group) {
                return `${group}`;
              }
            }
          }
          if (vm.loginData.role === 'Representative') {
            defaultOptions.select = false;
            defaultOptions.colReorder = {
              order: [0, 1, 2, 3, 4, 5]
            };
          }
          break;

        case 'allProfilesReportData':
          defaultOptions.rowGroup = {
            dataSrc: ['partnerIdentity'],
            startRender: function (rows, group) {
              return `${group}`;
            }
          };
          break;
        case 'allFeedbacksReportData':
          defaultOptions.rowGroup = {
            dataSrc: ['partnerIdentity'],
            startRender: function (rows, group) {
              return `${group}`;
            }
          };
          break;


        case 'awaitingPartnerInvoiceFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'financialsNotInvoiced',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });
          break;
        case 'attachedPartnerInvoiceFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'financialsInvoiced',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'invoicedPreviewForAmhInvoice':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'invoicedPreviewForAmhInvoice',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            searching: false,
            paging: false,
            responsive: true,
            processing: true,
            serverSide: true,
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'sentAmhInvoiceFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'sentAmhInvoiceFinancials',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }
          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'awaitingAmhRemittanceFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'awaitingAmhRemittanceFinancials',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'awaitingPartnerReceiptFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'awaitingPartnerReceiptFinancials',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'receivedPartnerReceiptFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'receivedPartnerReceiptFinancials',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'completedFinancials':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'completedFinancials',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;

        case 'financeStageReports':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllFinanceCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'reportsAllFinance',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'openStageReports':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/report/action/fetchAllOpenCases`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'reportsAllOpen',
                  repData: vm.tableData.currentData,
                  filterForPartner: vm.filterForPartner,
                  financeReportsYear: vm.financeReportsYear,
                  financeReportsPocket: vm.financeReportsPocket,
                  financeReportsGroup: vm.financeReportsGroup,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
            if (financeReportsGroupRowBool) {
              rowGrouping.push(financeReportsGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;

        case 'partnersAdmin':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/admin/action/fetchAllData`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'partnersAdmin',
                  repData: vm.tableData.currentData,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.adminGroup, function (partnerAdminGroupRowBool, partnerAdminGroupRowName) {
            if (partnerAdminGroupRowBool) {
              rowGrouping.push(partnerAdminGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'usersAdmin':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/admin/action/fetchAllData`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'usersAdmin',
                  repData: vm.tableData.currentData,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.adminGroup, function (partnerAdminGroupRowBool, partnerAdminGroupRowName) {
            if (partnerAdminGroupRowBool) {
              rowGrouping.push(partnerAdminGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
        case 'preapprovalsAdmin':
          defaultOptions = {
            ajax: {
              url: `${vm.$apiBaseURL}/admin/action/fetchAllData`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              data: function (d) {
                let postData = vm.$_.assignIn({}, d, {
                  dataFor: 'preapprovalsAdmin',
                  repData: vm.tableData.currentData,
                  searchBuilder: vm.thisDT ? vm.thisDT.searchBuilder.getDetails(true) : {}
                });
                vm.currentDisplayedDataConfig[vm.tableRef] = postData;
                return JSON.stringify(postData);
              },
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`,
                appVer: `${vm.$appVer}`
              }
            },
            responsive: true,
            processing: true,
            serverSide: true,
            layout: {
              top3: ['searchBuilder',
              ],
              top2Start: [
                'pageLength',
                {
                  buttons: [
                    'spacer',
                    {
                      extend: 'collection',
                      text: 'Columns',
                      buttons: [
                        {
                          popoverTitle: 'Visibility',
                          extend: 'colvis',
                          collectionLayout: 'two-column'
                        }
                      ]
                    },
                    'spacer',
                    {
                      text: 'Reload',
                      action: function () {
                        vm.thisDT.ajax.reload();
                      }
                    }
                  ]
                }
              ],
              top2End: [
                {
                  buttons: [
                    {
                      text: 'Export',
                      action: function () {
                        vm.displayExportModal();
                      }
                    },
                  ]
                }
              ],
              topStart: 'info',
              bottomStart: [{
                buttons: ['copy', 'csvHtml5', {
                  extend: 'pdfHtml5',
                  title: 'Finance Stage Report Data'
                }, 'print']
              }]
            },
            language: {
              search: 'Quick Search:',
              searchBuilder: {
                add: '+',
                delete: 'Delete',
                deleteTitle: 'Delete Title',
                data: 'Column',
                left: 'Left',
                leftTitle: 'Left Title',
                right: 'Right',
                rightTitle: 'Right Title',
                title: {
                  0: 'Filters',
                  _: 'Filters (%d)'
                },
              }
            }
          }

          vm.$_.forEach(vm.adminGroup, function (partnerAdminGroupRowBool, partnerAdminGroupRowName) {
            if (partnerAdminGroupRowBool) {
              rowGrouping.push(partnerAdminGroupRowName);
            }
          });

          defaultOptions = vm.$_.assignIn({}, defaultOptions, {
            rowGroup: {
              dataSrc: rowGrouping
            }
          });

          break;
      }

      return defaultOptions;
    },
  },
  watch: {
    financeReportsYear: {
      handler() {
        let vm = this;
        vm.thisDT.ajax.reload();
      },
      deep: true
    },
    financeReportsPocket: {
      handler() {
        let vm = this;
        vm.thisDT.ajax.reload();
      },
      deep: true
    },
    financeReportsGroup: {
      handler() {
        let vm = this;
        let rowGrouping = [];

        vm.$_.forEach(vm.financeReportsGroup, function (financeReportsGroupRowBool, financeReportsGroupRowName) {
          if (financeReportsGroupRowBool) {
            rowGrouping.push(financeReportsGroupRowName);
          }
        });
        vm.thisDT.rowGroup().dataSrc(rowGrouping)
        vm.thisDT.ajax.reload();
      },
      deep: true
    },
    drawTime: {
      handler() {
        let vm = this;
        vm.thisDT.ajax.reload();
      },
      deep: true
    },
    updatePatientInvoiceRefresh: {
      handler() {
        let vm = this;
        vm.thisDT.ajax.reload();
      },
      deep: true
    },
    invoiceAddingTime: {
      handler() {
        let vm = this,
            selectedRows = [],
            totalUSD = 0,
            caseIdAccYear = [];

        vm.$_.forEach(vm.rowSelectedCheck, function (included, caseid) {
          if (included) {
            vm.$_.forEach(vm.currentDisplayedDataFull.invoicedPreviewForAmhInvoice, function (rowData) {
              if (caseid === rowData.caseid) {
                selectedRows.push({
                  patientName: rowData.p_name,
                  inpatientNumber: rowData.p_inpatientnumber,
                  invoiceNumber: rowData.prt_inv_number,
                  safeAsk: rowData.p_safeaskamount
                });
                totalUSD += parseInt(rowData.p_safeaskamount);
                caseIdAccYear.push(`${rowData.caseid}_${rowData.partnerid}_${rowData.recordyear}`)
              }
            })
          }
        });

        vm.$emit('selectedInvoiceRows', {selectedRows: selectedRows, totalUSD: totalUSD, caseIdAccYear: caseIdAccYear});

      },
      deep: true
    }
  },
  created() {
    let vm = this;
    window.displayPartnerRemittanceModal = vm.displayPartnerRemittanceModal;
    window.displayExportModal = vm.displayExportModal;
  }
}
</script>

<template>
  <div class="table-container">

    <DataTable v-bind:data="tableData.data"
               ref="fundsUtilizationReportDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               class="table is-hoverable is-fullwidth is-striped fundsUtilizationReportData-Table middle-aligned-cells"
               v-if="tableRef==='fundsUtilizationReportData'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="allProfilesReportDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               class="table is-hoverable is-fullwidth is-striped allProfilesReportData-Table middle-aligned-cells"
               v-if="tableRef==='allProfilesReportData'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="allFeedbacksReportDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               class="table is-hoverable is-fullwidth is-striped allFeedbacksReportData-Table middle-aligned-cells"
               v-if="tableRef==='allFeedbacksReportData'">
    </DataTable>

    <DataTable v-bind:data="tableData.data"
               ref="awaitingPartnerInvoiceFinancialsDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped awaitingPartnerInvoiceFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='awaitingPartnerInvoiceFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="attachedPartnerInvoiceFinancialsDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped attachedPartnerInvoiceFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='attachedPartnerInvoiceFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="invoicedPreviewForAmhInvoice"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped invoicedPreviewForAmhInvoice-Table middle-aligned-cells dt-table"
               v-if="tableRef==='invoicedPreviewForAmhInvoice'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="sentAmhInvoiceFinancials"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped sentAmhInvoiceFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='sentAmhInvoiceFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="awaitingAmhRemittanceFinancials"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped awaitingAmhRemittanceFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='awaitingAmhRemittanceFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="awaitingPartnerReceiptFinancials"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped awaitingPartnerReceiptFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='awaitingPartnerReceiptFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="receivedPartnerReceiptFinancials"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped receivedPartnerReceiptFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='receivedPartnerReceiptFinancials'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="completedFinancials"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped completedFinancials-Table middle-aligned-cells dt-table"
               v-if="tableRef==='completedFinancials'">
    </DataTable>

    <DataTable v-bind:data="tableData.data"
               ref="openStageReportsDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped openStageReports-Table middle-aligned-cells"
               v-if="tableRef==='openStageReports'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="financeStageReportsDataTable"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped financeStageReports-Table middle-aligned-cells"
               v-if="tableRef==='financeStageReports'">
    </DataTable>

    <DataTable v-bind:data="tableData.data"
               ref="partnersAdmin"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped partnersAdmin-Table middle-aligned-cells"
               v-if="tableRef==='partnersAdmin'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="usersAdmin"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped usersAdmin-Table middle-aligned-cells"
               v-if="tableRef==='usersAdmin'">
    </DataTable>
    <DataTable v-bind:data="tableData.data"
               ref="preapprovalsAdmin"
               v-bind:columns="tableData.columns"
               v-bind:options="tableOptions"
               v-on:draw="xhrReportDraw"
               v-on:preXhr="preXhr"
               v-on:xhr="xhr"
               v-on:dtsb-inserted="dtsbInserted"
               class="table is-hoverable is-fullwidth is-striped preapprovalsAdmin-Table middle-aligned-cells"
               v-if="tableRef==='preapprovalsAdmin'">
    </DataTable>

  </div>

  <div class="modal" v-bind:class="{'is-active':showPartnerRemittanceModal}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Remittance information</p>
        <button class="delete" aria-label="close" v-on:click="showPartnerRemittanceModal=false;"></button>
      </header>
      <section class="modal-card-body">

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Remittance Reference</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="text" placeholder="Remittance Reference">
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Remittance Amount</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="text" placeholder="Remittance Amount">
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Remittance Date</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="text" placeholder="Remittance Date">
              </div>
            </div>
          </div>
        </div>

      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <button class="button is-success">Save</button>
          <button class="button" v-on:click="showPartnerRemittanceModal=false;">Cancel</button>
        </div>
      </footer>
    </div>
  </div>

  <ModalsContainer/>
</template>

<style scoped>

@import '@/assets/DataTables/datatables.min.css';

.table-container {
  position: relative;
  clear: both;
}

.no-margin {
  margin: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.checkbox-wrapper-26 * {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.checkbox-wrapper-26 input[type="checkbox"] {
  display: none;
}

.checkbox-wrapper-26 label {
  --size: 20px;
  --shadow: calc(var(--size) * .07) calc(var(--size) * .1);

  position: relative;
  display: block;
  width: var(--size);
  height: var(--size);
  margin: 0 auto;
  background-color: #f72414;
  border-radius: 50%;
  box-shadow: 0 var(--shadow) #ffbeb8;
  cursor: pointer;
  transition: 0.2s ease transform, 0.2s ease background-color,
  0.2s ease box-shadow;
  overflow: hidden;
  z-index: 1;
}

.checkbox-wrapper-26 label:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  width: calc(var(--size) * .7);
  height: calc(var(--size) * .7);
  margin: 0 auto;
  background-color: #fff;
  transform: translateY(-50%);
  border-radius: 50%;
  box-shadow: inset 0 var(--shadow) #ffbeb8;
  transition: 0.2s ease width, 0.2s ease height;
}

.checkbox-wrapper-26 label:hover:before {
  width: calc(var(--size) * .55);
  height: calc(var(--size) * .55);
  box-shadow: inset 0 var(--shadow) #ff9d96;
}

.checkbox-wrapper-26 label:active {
  transform: scale(0.9);
}

.checkbox-wrapper-26 .tick_mark {
  position: absolute;
  top: -1px;
  right: 0;
  left: calc(var(--size) * -.05);
  width: calc(var(--size) * .6);
  height: calc(var(--size) * .6);
  margin: 0 auto;
  margin-left: calc(var(--size) * .14);
  transform: rotateZ(-40deg);
}

.checkbox-wrapper-26 .tick_mark:before,
.checkbox-wrapper-26 .tick_mark:after {
  content: "";
  position: absolute;
  background-color: #fff;
  border-radius: 2px;
  opacity: 0;
  transition: 0.2s ease transform, 0.2s ease opacity;
}

.checkbox-wrapper-26 .tick_mark:before {
  left: 0;
  bottom: 0;
  width: calc(var(--size) * .1);
  height: calc(var(--size) * .3);
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.23);
  transform: translateY(calc(var(--size) * -.68));
}

.checkbox-wrapper-26 .tick_mark:after {
  left: 0;
  bottom: 0;
  width: 100%;
  height: calc(var(--size) * .1);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.23);
  transform: translateX(calc(var(--size) * .78));
}

.checkbox-wrapper-26 input[type="checkbox"]:checked + label {
  background-color: #07d410;
  box-shadow: 0 var(--shadow) #92ff97;
}

.checkbox-wrapper-26 input[type="checkbox"]:checked + label:before {
  width: 0;
  height: 0;
}

.checkbox-wrapper-26 input[type="checkbox"]:checked + label .tick_mark:before,
.checkbox-wrapper-26 input[type="checkbox"]:checked + label .tick_mark:after {
  transform: translate(0);
  opacity: 1;
}

</style>